let baseUrl = 'https://seeroo.mn';

export default {
    HOST: baseUrl,
    IMG_HOST: baseUrl,
};
